import React from "react";
import styled from "styled-components";

interface CheckProps {
  check: boolean;
}

interface ToggleBtnProps extends CheckProps {
  checkEvent: () => void;
}

export default function ToggleBtn({ check, checkEvent }: ToggleBtnProps) {
  return (
    <ToggleBtnContainer onClick={() => checkEvent()} check={check}>
      <Handle check={check} />
    </ToggleBtnContainer>
  );
}

const ToggleBtnContainer = styled.div<CheckProps>`
  cursor: pointer;
  position: relative;
  width: 40px;
  height: 24px;
  border-radius: 12px;
  background-color: ${({ check, theme }) =>
    check ? theme.buttonColor.blueNormal : theme.buttonColor.lineHover};
  display: flex;
  align-items: center;
  padding: 3.5px;
`;

const Handle = styled.div<CheckProps>`
  position: absolute;
  width: 19px;
  height: 19px;
  background-color: #ffffff;
  border-radius: 50%;
  top: 2px;
  left: ${({ check }) => (check ? 18 : 3)}px;
  transition: left 0.2s ease;
`;
